import * as api from "../api/index";

import {
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  GET_INVOICE_BY_ORDERNO,
  FETCH_INVOICE_BY_USER,
  FETCH_INVOICE_BY_CLIENT,
  FETCH_INVOICE_BY_SUPPLIER,
  FETCH_INVOICE_BY_DEALER,
  FETCH_INVOICE_BY_PAGE,
  FETCH_ALL,
  FETCH_STATS,
  START_LOADING,
  END_LOADING,
} from "./constants";

export const getInvoices = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoices();
    // console.log(data)
    dispatch({ type: FETCH_ALL, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};
export const getInvoicesByPage =
  (page, rowsPerPage, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchInvoicesByPage({
        page,
        rowsPerPage,
        startDate,
        endDate,
      });

      dispatch({ type: FETCH_INVOICE_BY_PAGE, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error);
    }
  };
export const getInvoicesByUser =
  (page, rowsPerPage, id, startDate, endDate) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchInvoicesByUser({
        page,
        rowsPerPage,
        id,
        startDate,
        endDate,
      });
      ;
      dispatch({ type: FETCH_INVOICE_BY_USER, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error.response);
    }
  };

export const getInvoicesByClient =
  (page, rowsPerPage, id, startDate, endDate, creator) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchInvoicesByClient({
        page,
        rowsPerPage,
        id,
        startDate,
        endDate,
        creator,
      });
      dispatch({ type: FETCH_INVOICE_BY_CLIENT, payload: data });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error.response);
    }
  };
export const getInvoicesBySupplier =
  (page, rowsPerPage, id, startDate, endDate, creator) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoicesBySupplier({
      page,
      rowsPerPage,
      id,
      startDate,
      endDate,
      creator,
    });
    dispatch({ type: FETCH_INVOICE_BY_SUPPLIER, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};

export const getInvoicesByDealer = (page, rowsPerPage, dealerId, startDate, endDate, partyId, supplierId) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoicesByDealer({
      page,
      rowsPerPage,
      dealerId,
      startDate,
      endDate,
      partyId,
      supplierId,
    });
    dispatch({ type: FETCH_INVOICE_BY_DEALER, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};
export const getInvoicesStats = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchInvoicesStats({ id });
    // console.log(data)
    dispatch({ type: FETCH_STATS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};
export const getInvoice = (id) => async (dispatch) => {
  if (!id) return; // Guard: don't call API with undefined id
  const user = JSON.parse(localStorage.getItem("profile"));

  try {
    const { data } = await api.fetchInvoice(id);
    // console.log("getInvoicedata",data)
    const businessDetails = await api.fetchProfilesByUser(user.result._id);
    // console.log("Business Details: " ,businessDetails)
    const invoiceData = { ...data, businessDetails };

    // console.log("invoice Data",invoiceData)
    dispatch({ type: GET_INVOICE, payload: invoiceData });
  } catch (error) {
    console.log(error.response);
  }
};
export const getInvoiceByOrderNo = (orderNo) => async (dispatch) => {
  ;
  const user = JSON.parse(localStorage.getItem("profile"));

  try {
    const { data } = await api.fetchInvoiceByOrderNo(orderNo);
    // console.log("getInvoicedata",data)
    const businessDetails = await api.fetchProfilesByUser(user.result._id);
    // console.log("Business Details: " ,businessDetails)
    const invoiceData = { ...data, businessDetails };

    // console.log("invoice Data",invoiceData)
    dispatch({ type: GET_INVOICE_BY_ORDERNO, payload: invoiceData });
  } catch (error) {
    console.log(error.response);
  }
};
export const createInvoice = (invoice, history) => async (dispatch) => {
  try {
    console.log("Create Invoice Called");
    dispatch({ type: START_LOADING });
    const { data } = await api.addInvoice(invoice);
    console.log("Created Invoice Data", data);
    dispatch({ type: ADD_NEW, payload: data });
    history.push(`/invoice/${data._id}`);
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const updateInvoice = (id, invoice, history) => async (dispatch) => {
  try {
    const { data } = await api.updateInvoice(id, invoice);
    history.push(`/invoice/${data._id}`);
    dispatch({ type: UPDATE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const deleteInvoice = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteInvoice(id);

    dispatch({ type: DELETE, payload: id });
    openSnackbar("Order deleted successfully");
  } catch (error) {
    console.log(error.response);
  }
};
